import { createSlice } from '@reduxjs/toolkit';

const formoptionsSlice = createSlice({
  name: 'options',
  initialState: { options: {
    regions: {}
  } },
  reducers: {
    setFormOptions: (state, action) => {
      state.options = action.payload;
    },
  },
});

export const { setFormOptions } = formoptionsSlice.actions;

export default formoptionsSlice.reducer;